import i18n from '@/utils/i18n';
import React from 'react';
import { ActivityNotesListSkeleton } from '@/experiences/sales-portal/components/activity-notes/activity-notes-list-skeleton';
import { AnimatedSkeletonLoader } from '@usepepper/ui/atoms/animated-skeleton-loader';
import { useActivityNoteStyles } from '@/experiences/sales-portal/components/activity-notes/utils';
import { YStack } from '@usepepper/sprout-kit-ui';

const TITLE_BAR_HEIGHT = 20;
const TITLE_BAR_WIDTH = 72;

export const ActivityNotesDesktopSkeleton: React.FC = () => {
  const [styles, theme] = useActivityNoteStyles();

  return (
    <YStack
      accessibilityLabel={i18n.t('sales_portal.activity_notes.loading')}
      accessibilityRole="progressbar"
    >
      <YStack style={[styles.sectionHeader, styles.sectionHeaderDesktop]}>
        <AnimatedSkeletonLoader
          borderRadius={theme.sk.radii.radiusRound}
          height={TITLE_BAR_HEIGHT}
          width={TITLE_BAR_WIDTH}
        />
      </YStack>
      <ActivityNotesListSkeleton />
    </YStack>
  );
};
